<!--
 * @Description:
 * @version:
 * @Author: knight
 * @Date: 2022-01-23 15:09:09
 * @LastEditors: knight
 * @LastEditTime: 2022-01-23 16:14:21
-->
<template>
  <div>
    <button class="cals" :disabled="!canDec" @click="decrease">-</button>
    <input class="num" type="number" v-model="valueCache" @blur="onBlur" />
    <button class="cals" :disabled="!canInc" @click="increase">+</button>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'update:value',
  },
  props: {
    value: {
      type: Number,
      require: true,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      valueCache: null,
    };
  },
  created() {
    this.valueCache = this.value;
  },
  watch: {
    value(val) {
      this.valueCache = val;
    },
  },
  computed: {
    canDec() {
      return this.min === undefined || this.min <= this.value - this.step;
    },
    canInc() {
      return this.max === undefined || this.max >= this.value + this.step;
    },
  },
  methods: {
    decrease() {
      this.$emit('update:value', this.value - this.step);
    },
    increase() {
      this.$emit('update:value', this.value + this.step);
    },
    onBlur() {
      const val = Number(this.valueCache);
      if (
        (val >= this.min || this.min === undefined) &&
        (val <= this.max || this.max === undefined)
      ) {
        this.$emit('update:value', val);
      } else {
        const resetVal = this.min || 1;
        this.valueCache = resetVal;
        this.$emit('update:value', resetVal);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.num {
  width: 114px;
  height: 44px;
  line-height: 44px;
  color: #545454;
  background: #f2f2f2;
  text-align: center;
  margin: 0px 20px;
  border: none;
}

.cals {
  border: none;
  font-size: 32px;
  color: #323232;
  background: none;
}
</style>
